import type { App } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import routeRecordRaw from './modules/remaining'

const router = createRouter({
  // __APP_ROUTER_BASE__ 使用 define 注入
  history: createWebHistory(__APP_ROUTER_BASE__), // createWebHashHistory URL带#， createWebHistory URL不带#
  strict: true,
  routes: routeRecordRaw,
  scrollBehavior() {
    // TODO: 不生效， 后续看看这里要怎么写
    return { el: '.el-main', top: 0 }
  }
})

export const resetRouter = (): void => {
  // TODO: 这里的白名单暂时没处理，后续需要处理下
  const resetWhiteNameList = ['Redirect', 'Login', 'NoFound', 'Home']
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !resetWhiteNameList.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
